module.exports = __webpack_public_path__ + "img/4-9accident.51fe9401.png";